$(function () {
  if (!customElements.get('about-global-vision')) {
    customElements.define(
      'about-global-vision',
      class aboutGlobalVision extends HTMLElement {
        constructor() {
          super();
          this._io = null;
        }

        connectedCallback() {
          this.init();
          this.initCountUp();
        }

        disconnectedCallback() {
          if (this._io) {
            this._io.disconnect();
            this._io = null;
          }
        }

        init() {
          let flagWidth = 80;
          let flagHeight = 80;
          let $mapMainDom = $(this).find('.map_main');
          let $mapDom = $mapMainDom.find('svg');
          let countryList = $mapMainDom.data('countryIds')?.split(',');

          if (countryList?.length > 0) {
            countryList = [...new Set(countryList)];
            countryList.forEach((item) => {
              let $pathDom = $mapDom.find(`#${item}`);
              if ($pathDom.length) {
                let box = $pathDom[0].getBBox();
                let flagX = box.x + box.width / 2 - flagWidth / 2;
                let flagY = box.y + box.height / 2 - flagHeight / 2;
                let $flagDoms = $mapMainDom.find(`.flag.${item}`);

                $flagDoms.each((index, flagDom) => {
                  let $flagDom = $(flagDom);
                  if (index === 0) {
                    $flagDom.css({
                      left: `${flagX}px`,
                      top: `${flagY}px`,
                    });
                  } else {
                    $flagDom.hide();
                  }
                });
              }
            });
          }
        }

        initCountUp() {
          const $numberDomList = $(this).find('.count');
          if (!$numberDomList.length) return;

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                if (el.dataset.animated === 'true') {
                  observer.unobserve(el);
                  return;
                }
                el.dataset.animated = 'true';

                const target = Number(el.getAttribute('data-number')) || 0;
                const duration = 1200; // ms
                const startTime = performance.now();

                const step = (now) => {
                  const progress = Math.min((now - startTime) / duration, 1);
                  const eased = this._easeOutCubic(progress);
                  const current = Math.floor(target * eased);
                  el.textContent = this._formatNumber(current);

                  if (progress < 1) {
                    requestAnimationFrame(step);
                  } else {
                    el.textContent = this._formatNumber(target);
                  }
                };

                el.textContent = '0';
                requestAnimationFrame(step);

                observer.unobserve(el);
              });
            },
            { threshold: 0.3 }
          );

          $numberDomList.each((_, item) => observer.observe(item));
          this._io = observer;
        }

        _formatNumber(value) {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'K';
          } else {
            return value.toString();
          }
        }

        _easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
      }
    );
  }
});
